import React from 'react'
import { FormControl, Checkbox, FormControlLabel } from '@mui/material'

const CustomCheckbox = ({ defaultChecked, label, width, onChange, style }) => {
  return (
        <FormControl className="formcontrol" variant="outlined" size="small" sx={{ width: width || 'auto' }}>
            <FormControlLabel control={<Checkbox checked={defaultChecked} onChange={onChange} />} label={label} sx={style} />
        </FormControl>
  );
}

export default CustomCheckbox